const SLATE_SUBMIT_SELECTORS =
  '.form_button_submit, button.default, input[type="submit"]';

export const SLATE_FORM_EMBED_SCOPE = "#form-embed";

export function scopeFormCss(css, scope = SLATE_FORM_EMBED_SCOPE) {
  if (!css?.trim()) return "";
  return css.replace(/(^|})(\s*[^{]+)\{/g, (_match, prefix, selector) => {
    const scopedSelector = selector
      .split(",")
      .map((sel) => {
        const trimmed = sel.trim();
        return trimmed ? `${scope} ${trimmed}` : trimmed;
      })
      .join(", ");
    return `${prefix}${scopedSelector} {`;
  });
}

export function clearSlateSubmitInlineStyles(root) {
  root.querySelectorAll(SLATE_SUBMIT_SELECTORS).forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    node.style.removeProperty("background-color");
    node.style.removeProperty("color");
    node.style.removeProperty("background");
  });
}

export function watchSlateSubmitInlineStyles(root) {
  clearSlateSubmitInlineStyles(root);
  const observer = new MutationObserver(() => {
    clearSlateSubmitInlineStyles(root);
  });
  observer.observe(root, {
    attributes: true,
    attributeFilter: ["style"],
    childList: true,
    subtree: true,
  });
  return () => observer.disconnect();
}
